module.exports = __webpack_public_path__ + "img/red-desert-decal-03.41a3c664.png";